import request from '@/utils/request'
export async function getArtshare () {
    return await request.post('/api/artArticles/PcqueryAllByLimit')
}

// getNews().then(res => {
//     console.log(res)
// })